import React from "react";
import { components } from "react-select";
import Select from "react-select";
import { Field } from "react-final-form";

export default function PublisheeSelector({ input, options, meta, info, label, required, noLabel, disabled, readOnly, autoFocus, fieldHelpLink }) {
    return (
        <Field name={input.name}>
            {(props) => {
                const { value = [], onChange } = props.input;
                const {
                    meta: { touched, error },
                } = props;
                const isError = touched && error;
                const _onChange = (selectedOptions) => {
                    const mappedValues = selectedOptions ? selectedOptions.map((v) => v.value) : [];
                    const uniqueValues = Array.from(new Set(mappedValues));
                    onChange(uniqueValues);
                };
                const vmOptions = options
                    .filter((o) => ![...value].find((v) => v === o.value))
                    .map((p) => ({ ...p, label: p.text }))
                    .reduce((acc, p) => {
                        const groupIndex = !isNaN(p.groupIndex) ? p.groupIndex : 0;
                        const groupLabel = p.groupLabel || "";
                        if (!groupLabel) {
                            acc.push(p);
                        } else {
                            const group = acc.find((g) => g.groupLabel === groupLabel);
                            if (group) {
                                group.options.push(p);
                            } else {
                                acc.push({ groupLabel, label: groupLabel, groupIndex, options: [p] });
                            }
                        }
                        return acc;
                    }, [])
                    .sort((a, b) => (a.groupIndex > b.groupIndex ? 1 : -1));
                const uniqueIds = Array.from(new Set(options.map((o) => o.value)));
                const vmSelectedOptions = uniqueIds
                    .filter((o) => value.includes(o))
                    .map((id) => {
                        const option = options.find((o) => o.value === id);
                        return {
                            ...option,
                            label: option.text,
                        };
                    });

                return (
                    <div className={`Field ${isError ? "has-error" : ""}`}>
                        <label htmlFor={input.name} className="Select Select--block">
                            {noLabel !== true && (
                                <span className={`Field-label${disabled ? " is-disabled" : ""}`}>
                                    {label}
                                    {required === true && <sup className="required">*</sup>}
                                    {fieldHelpLink}
                                </span>
                            )}
                            <Select
                                {...input}
                                value={vmSelectedOptions}
                                id={input.name}
                                onChange={_onChange}
                                options={vmOptions}
                                isMulti={true}
                                components={{ ClearIndicator, DropdownIndicator }}
                                closeMenuOnSelect={false}
                                classNamePrefix="ovr_multiSelect"
                                menuShouldScrollIntoView={false}
                                styles={colourStyles}
                                //wrap
                                placeholder="Select publishee's"
                            />
                        </label>
                        {isError && (
                            <small className="Field-error u-mt-xs" id={`${input.name}-error`}>
                                {error}
                            </small>
                        )}
                    </div>
                );
            }}
        </Field>
    );
}

const colourStyles = {
    multiValue: (styles) => {
        return {
            ...styles,
            background: "repeating-linear-gradient(-60deg, #4591b9, #4591b9 5px, #549bc0 5px, #549bc0 10px) !important",
            color: "#fff !important",
            padding: "5px 10px !important",
            marginRight: "3px !important",
            marginBottom: "3px !important",
        };
    },
    groupHeading: (base) => ({
        ...base,
        textTransform: "none", // override the uppercase
        fontWeight: "bold", // optional: adjust font weight
        fontSize: "14px", // optional: adjust font size
    }),
};

const ClearIndicator = (props) => {
    return (
        <components.ClearIndicator {...props}>
            <i className="icon icon-cross-circle" title="Clear all" />
        </components.ClearIndicator>
    );
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <i className="icon icon-arrow-filled" />
        </components.DropdownIndicator>
    );
};
